<template>
  <div class="dashboard">
    <!-- HEADER -->
    <header class="header">
      <h1>Reporteador en Tiempo Real</h1>
      <span class="status">Simulación Activa</span>
    </header>

    <!-- FILTROS -->
    <section class="filters">
      <input v-model="filtros.buscar" placeholder="Buscar..." />

      <select v-model="filtros.estatus">
        <option value="">Todos</option>
        <option value="1">Activo</option>
        <option value="0">Inactivo</option>
      </select>

      <button @click="simularDatos">Refrescar</button>
    </section>

    <!-- KPIs -->
    <section class="kpis">
      <div class="card">
        <h3>Total</h3>
        <p>{{ kpis.total }}</p>
      </div>

      <div class="card">
        <h3>Activos</h3>
        <p>{{ kpis.activos }}</p>
      </div>

      <div class="card">
        <h3>Inactivos</h3>
        <p>{{ kpis.inactivos }}</p>
      </div>

      <div class="card highlight">
        <h3>Último ID</h3>
        <p>{{ ultimoId }}</p>
      </div>
    </section>

    <!-- TABLA -->
    <section class="tabla">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Nombre</th>
            <th>Estatus</th>
            <th>Fecha</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in dataFiltrada" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.nombre }}</td>
            <td>
              <span :class="item.estatus == 1 ? 'activo' : 'inactivo'">
                {{ item.estatus == 1 ? 'Activo' : 'Inactivo' }}
              </span>
            </td>
            <td>{{ item.fecha }}</td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>
export default {
  name: "Reporteador",

  data() {
    return {
      data: [],
      filtros: {
        buscar: "",
        estatus: ""
      },
      kpis: {
        total: 0,
        activos: 0,
        inactivos: 0
      },
      intervalo: null,
      contador: 1
    };
  },

  computed: {
    dataFiltrada() {
      return this.data.filter(x => {
        const matchTexto = x.nombre
          .toLowerCase()
          .includes(this.filtros.buscar.toLowerCase());

        const matchEstatus =
          this.filtros.estatus === "" ||
          x.estatus == this.filtros.estatus;

        return matchTexto && matchEstatus;
      });
    },

    ultimoId() {
      return this.data.length > 0 ? this.data[0].id : 0;
    }
  },

  methods: {
    generarRegistro() {
      const estatus = Math.random() > 0.5 ? 1 : 0;

      return {
        id: this.contador++,
        nombre: "Registro " + Math.floor(Math.random() * 100),
        estatus: estatus,
        fecha: new Date().toLocaleTimeString()
      };
    },

    simularDatos() {
      for (let i = 0; i < 3; i++) {
        this.data.unshift(this.generarRegistro());
      }

      if (this.data.length > 50) {
        this.data.pop();
      }

      this.calcularKPIs();
    },

    calcularKPIs() {
      this.kpis.total = this.data.length;
      this.kpis.activos = this.data.filter(x => x.estatus == 1).length;
      this.kpis.inactivos = this.data.filter(x => x.estatus == 0).length;
    }
  },

  mounted() {
    console.log("🔥 Reporteador cargado correctamente (Vue 2)");

    this.simularDatos();

    this.intervalo = setInterval(() => {
      this.simularDatos();
    }, 2000);
  },

  beforeDestroy() {
    clearInterval(this.intervalo);
  }
};
</script>

<style scoped>
.dashboard {
  padding: 20px;
  font-family: Arial;
  background: #f9fafb;
}

/* HEADER */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.status {
  padding: 5px 10px;
  border-radius: 5px;
  background: green;
  color: white;
}

/* FILTROS */
.filters {
  margin: 20px 0;
  display: flex;
  gap: 10px;
}

.filters input,
.filters select {
  padding: 5px;
}

/* KPIs */
.kpis {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.card {
  background: white;
  padding: 15px;
  border-radius: 12px;
  width: 150px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

.highlight {
  background: #2563eb;
  color: white;
}

/* TABLA */
.tabla table {
  width: 100%;
  border-collapse: collapse;
  background: white;
}

.tabla th,
.tabla td {
  border: 1px solid #eee;
  padding: 10px;
}

.activo {
  color: green;
  font-weight: bold;
}

.inactivo {
  color: red;
  font-weight: bold;
}
</style>